import { useEffect, useState } from "react";
import { OperatingLayout } from "../../../layouts/operating/OperatingLayout";
import { getMemberData } from "../../../utils/helpers/getMemberData";
import { useAccount } from "@vojomo-core/shared";

export const WeeklyAgendaForm = () => {
  const { companyName } = useAccount();
  const [memberAgendaFormLink, setMemberAgendaFormLink] = useState("");

  useEffect(() => {
    getMemberData(companyName).then((memberInfo) => {
      if (memberInfo !== null) {
        const memberLink: string = memberInfo.member_agenda_form_link;
        setMemberAgendaFormLink(memberLink);
      }
    });
  }, [companyName]);

  const iframeEl = memberAgendaFormLink ? (
    <iframe
      style={{
        borderRadius: "10px",
        borderColor: "grey",
        borderWidth: "1px",
        borderStyle: "solid",
        width: "100%",
        height: "75vh"
      }}
      src={memberAgendaFormLink}
    />
  ) : (
    <></>
  );
  return (
    <OperatingLayout pageHeader="Weekly Agenda Form">
      {iframeEl}
    </OperatingLayout>
  );
};
